import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendAcceptPayload,
  BackendMutationAcceptUserInvitationArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation AcceptUserInvitation($token: String!, $password: String, $name: String) {
    acceptUserInvitation(token: $token, password: $password, name: $name) {
      token
      customerId
    }
  }
`;

type Variables = BackendMutationAcceptUserInvitationArgs;
type Result = BackendAcceptPayload;

export const acceptUserInvitation = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
